import React, { useState, useEffect } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { IconContext } from "react-icons/lib";
//prettier-ignore
import { Nav, NavbarContainer, NavLogo, NavImage, MobileIcon, NavMenu, NavItem, NavLinks } from "./Navbar.elements";
import glint from "../../images/glint.svg";

const Navbar = () => {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);

  const handleClick = () => {
    setClick(!click);
  };

  const showButton = () => {
    if (window.innerWidth <= 990) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  useEffect(() => {
    showButton();
  }, []);

  window.addEventListener("resize", showButton);

  return (
    <>
      <IconContext.Provider value={{ color: "#fff" }}>
        <Nav>
          <NavbarContainer>
            <NavLogo to="/home">
              <NavImage src={glint} />
            </NavLogo>
            <MobileIcon onClick={handleClick}>
              {click ? <FaTimes /> : <FaBars />}
            </MobileIcon>
            <NavMenu onClick={handleClick} click={click}>
              <NavItem>
                <NavLinks
                  to="/home"
                  activeStyle={{
                    height: "80px",
                    color: "black",
                    background: "#ffc043",
                    transition: "all 0.2s ease",
                  }}
                >
                  Owners
                </NavLinks>
              </NavItem>
              <NavItem>
                <NavLinks
                  to="/partners"
                  activeStyle={{
                    height: "80px",
                    color: "black",
                    background: "#ffc043",
                    transition: "all 0.2s ease",
                  }}
                >
                  Partners
                </NavLinks>
              </NavItem>
              <div tw="xl:mx-60 lg:mx-24" />
              <NavItem>
                <NavLinks
                  to="/process"
                  activeStyle={{
                    height: "80px",
                    color: "black",
                    background: "#ffc043",
                    transition: "all 0.2s ease",
                  }}
                >
                  Process
                </NavLinks>
              </NavItem>
              <NavItem>
                <NavLinks
                  to="/pricing"
                  activeStyle={{
                    height: "80px",
                    color: "black",
                    background: "#ffc043",
                    transition: "all 0.2s ease",
                  }}
                >
                  Pricing
                </NavLinks>
              </NavItem>
              {/* <NavItem>
                <NavLinks
                  to="/about"
                  activeStyle={{
                    height: "80px",
                    color: "black",
                    background: "#ffc043",
                    transition: "all 0.2s ease",
                  }}
                >
                  Company
                </NavLinks>
              </NavItem> */}
              <NavItem>
                <NavLinks
                  to="/subscribe"
                  activeStyle={{
                    height: "80px",
                    color: "black",
                    background: "#ffc043",
                    transition: "all 0.2s ease",
                  }}
                >
                  Subscribe
                </NavLinks>
              </NavItem>
              <NavItem>
                <NavLinks 
                to="/careers"
                activeStyle={{
                  height: "80px",
                  color: "black",
                  background: "#ffc043",
                  transition: "all 0.2s ease",
                }}>
                  Careers
                </NavLinks>
              </NavItem>
            </NavMenu>
          </NavbarContainer>
        </Nav>
      </IconContext.Provider>
    </>
  );
};

export default Navbar;
